var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('POIStep',{attrs:{"position":_vm.position,"step":_vm.step,"title":"Hütten"},on:{"changeStep":_vm.changeStep}},[_c('POIHutsStateFields',{attrs:{"editedItem":_vm.editedItem,"isOwnedBySubPrincipal":_vm.isOwnedBySubPrincipal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }